import { SetState, GetState } from 'zustand';
import { IVendorModel } from '../../../pages/UpdateVendor/interfaces';

export interface IVendorSlice {
    vendorList: IVendorModel[];
    selectedVendorId: string;
    setVendorList: (list: IVendorModel[]) => void;
    setSelectedVendorId: (id: string) => void;
    getSelectedVendor: () => IVendorModel | undefined
    resetVendorSlice: () => void;
}
const createVendorSlice = (set: SetState<IVendorSlice>, get: GetState<IVendorSlice>) => ({
  vendorList: [],
  selectedVendorId: '',
  resetVendorSlice: () => {
    set({
      vendorList: [],
      selectedVendorId: '',
    });
  },
  setVendorList: (payload: IVendorModel[]) => {
    set({ vendorList: payload });
  },
  setSelectedVendorId: (payload: string) => {
    set({ selectedVendorId: payload });
  },
  getSelectedVendor: () => {
    const list = get().vendorList;
    const id = get().selectedVendorId;
    return list.filter(v => v.supplierId === id)[0];
  },
});

export default createVendorSlice;
